var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendSurveyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3537 13.161H25.91",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9099 13.1599L8.58577 21.2916C8.38417 21.3665 8.15741 21.317 8.00533 21.165C7.85326 21.0129 7.80377 20.7861 7.87867 20.5845L10.3535 13.1599L7.87867 5.73527C7.80377 5.53366 7.85326 5.3069 8.00533 5.15483C8.15741 5.00275 8.38417 4.95327 8.58577 5.02816L25.9099 13.1599",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSurveyWhite);
export default __webpack_public_path__ + "static/media/sendSurveyWhite.23b6edd07ba441aa1517b7d7b21c5771.svg";
export { ForwardRef as ReactComponent };